import { Injectable } from '@angular/core';
import { ReminderService } from '../services/reminder.service';

@Injectable()
export class ReminderResolver {

  constructor(
    private reminderService: ReminderService
  ) {}

  init() {
    return this.reminderService.get().map((data) => {
        return { reminder: {
          subject: data.response.reminders[0].subject,
          message: data.response.reminders[0].header,
          enabled: data.response.reminders[0].enabled,
          id: data.response.reminders[0].id
        }};
      });
  }

}

